var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex acenter"},[_vm._t("default"),_vm._v(" "),_c('label',{staticClass:"c-switch__container"},[_c('input',{attrs:{"type":"checkbox"}}),_vm._v(" "),_c('span',{staticClass:"slider round",on:{"click":function($event){$event.stopPropagation();return _vm.toggle.apply(null, arguments)}}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }